/**
 * Module « Travaux » — la fiche d'UN travail, `/travaux/:code`.
 *
 * `sansNav: true` : on n'entre pas ici par la sidebar (un écran de fiche a
 * besoin d'un numéro, la sidebar n'en a aucun à proposer). On y arrive par un
 * lien — depuis Travaux du jour, une carte à relancer, le Kanban, la fiche
 * cabinet. Le registre monte quand même la route ; seul l'arbre de navigation
 * l'ignore (`arbreDeNav`, vague 2a).
 *
 * `label` et `icon` restent renseignés bien qu'invisibles aujourd'hui : le
 * contrat les exige, et le jour où une liste de travaux justifiera un lien de
 * nav, il n'y aura qu'un drapeau à retirer.
 */
import { lazy } from "react";
import type { ModuleDef } from "../../core/module-contract";

const mod: ModuleDef = {
  id: "travaux",
  label: "Travaux",
  icon: "i-check-sq",
  navGroup: "pilotage",
  navOrder: 99,
  rolesRequis: [],
  sansNav: true,
  routes: [{ path: "/travaux/:code", component: lazy(() => import("./routes/FicheTravail")) }],
};

export default mod;
